import { useEffect, useState } from 'react';
import api from '@/lib/api';
import { FileText, Loader2 } from 'lucide-react';

const LABELS = { pan: 'PAN Card', aadhaar: 'Aadhaar', photo: 'Photo' };

function Doc({ spId, type, meta }) {
  const [url, setUrl] = useState('');
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let obj;
    api.get(`/sales/persons/${spId}/kyc-doc/${type}`, { responseType: 'blob' })
      .then(r => { obj = URL.createObjectURL(r.data); setUrl(obj); }).catch(() => setFailed(true));
    return () => obj && URL.revokeObjectURL(obj);
  }, [spId, type]);
  const isPdf = meta?.content_type === 'application/pdf';
  return (
    <a href={url || undefined} target="_blank" rel="noreferrer" className="block border border-brand-border rounded-lg overflow-hidden hover:shadow-md transition-shadow" data-testid={`sp-doc-${type}`}>
      <div className="h-32 flex items-center justify-center bg-brand-bg">
        {!url && !failed ? <Loader2 className="animate-spin text-brand-primary" size={20} />
          : failed ? <span className="text-xs text-rose-600">Unavailable</span>
          : isPdf ? <FileText size={28} className="text-brand-primary" /> : <img src={url} alt={type} className="h-32 w-full object-cover" />}
      </div>
      <p className="text-xs font-medium px-2 py-1.5">{LABELS[type]}</p>
    </a>
  );
}

const FIELDS = [['full_name', 'Full Name'], ['date_of_birth', 'Date of Birth'], ['phone', 'Phone'], ['pan_number', 'PAN'],
  ['aadhaar_number', 'Aadhaar'], ['address', 'Address'], ['city', 'City'], ['state', 'State'], ['pin_code', 'PIN'],
  ['bank_holder_name', 'Account Holder'], ['bank_name', 'Bank'], ['bank_account_number', 'Account No.'], ['bank_ifsc', 'IFSC'], ['upi_id', 'UPI']];

export function SalesKycView({ spId, kyc }) {
  if (!kyc || kyc.status === 'draft') return <p className="text-sm text-brand-text-secondary" data-testid="sp-kyc-empty">KYC not submitted yet.</p>;
  return (
    <div className="space-y-4" data-testid="sp-kyc-view">
      <dl className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-4 gap-y-2 text-sm">
        {FIELDS.filter(([k]) => kyc[k]).map(([k, l]) => (
          <div key={k}><dt className="text-[11px] text-brand-text-secondary">{l}</dt><dd className="font-medium break-words">{kyc[k]}</dd></div>
        ))}
      </dl>
      <div className="grid grid-cols-3 gap-3 max-w-lg">
        {Object.entries(kyc.documents || {}).map(([t, m]) => <Doc key={t} spId={spId} type={t} meta={m} />)}
      </div>
    </div>
  );
}
